<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Kindred Spirit</span></p>
<p class="p0">By Paul Alan Fahey</p>
<p class="p4">“The sins of the fathers are visited upon the children.”</p>
<p class="p0">—Henrik Ibsen, <span class="t2">Ghosts</span></p>
<p class="p2"><a id="a3"></a><a href="#/005#a28">Chapter 1: A Damned Sensitive Soul</a></p>
<p class="p2"><a href="#/006#a29">Chapter 2: Fire and Brimstone</a></p>
<p class="p2"><a href="#/007#a30">Chapter 3: Big Things from Little Things Grow</a></p>
<p class="p2"><span href="#/008#a31" title="Link target outside of Sample">Chapter 4: Leslie’s Premonition</span></p>
<p class="p2"><span href="#/009#a32" title="Link target outside of Sample">Chapter 5: A Death in the Family</span></p>
<p class="p2"><span href="#/010#a33" title="Link target outside of Sample">Chapter 6: Homecoming</span></p>
<p class="p2"><span href="#/011#a34" title="Link target outside of Sample">Chapter 7: Act of Violence</span></p>
<p class="p2"><span href="#/012#a35" title="Link target outside of Sample">Chapter 8: Old Wounds</span></p>
<p class="p2"><span href="#/013#a36" title="Link target outside of Sample">Chapter 9: The Road to the Ruins</span></p>
<p class="p2"><span href="#/014#a37" title="Link target outside of Sample">Chapter 10: The Orphans’ Garden</span></p>
<p class="p2"><span href="#/015#a38" title="Link target outside of Sample">Chapter 11: Into the Past</span></p>
<p class="p2"><span href="#/016#a39" title="Link target outside of Sample">Chapter 12: Brief Interlude</span></p>
<p class="p2"><span href="#/017#a40" title="Link target outside of Sample">Chapter 13: Two Bits of Good News</span></p>
<p class="p2"><span href="#/018#a41" title="Link target outside of Sample">Chapter 14: Freud and Beyond</span></p>
<p class="p2"><span href="#/019#a42" title="Link target outside of Sample">Chapter 15: A Visit with Dot Perkins</span></p>
<p class="p2"><span href="#/020#a43" title="Link target outside of Sample">Chapter 16: Freud Again</span></p>
<p class="p2"><span href="#/021#a44" title="Link target outside of Sample">Chapter 17: A Journey North</span></p>
<p class="p2"><span href="#/022#a45" title="Link target outside of Sample">Chapter 18: An Interview with Mrs. Rose Baker</span></p>
<p class="p2"><span href="#/023#a46" title="Link target outside of Sample">Chapter 19: Facts and Suppositions</span></p>
<p class="p2"><span href="#/024#a47" title="Link target outside of Sample">Chapter 20: The Final Piece of the Puzzle</span></p>
<p class="p2"><span href="#/025#a48" title="Link target outside of Sample">Chapter 21: Sins of the Fathers</span></p>
<p class="p2"><span href="#/026#a49" title="Link target outside of Sample">Chapter 22: Kindred Spirits</span></p>
<p class="p2"><span href="#/027#a50" title="Link target outside of Sample">Chapter 23: Home</span></p>
<p class="p2"> </p>
<p class="p0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?45aa75c6